export class JsonEditorField {

  constructor (data, arrayItem: boolean, restrict: boolean) {
    
    this.key = data?.key;
    this.value = data?.value;
    this.type = data?.type;

    this.isArrayItem = arrayItem;

    this.disableAddKey = false;
    this.disableType = this.type === 'Null' ? false : restrict;
    this.disableRemove = restrict;
    this.disableValue = false;
    this.disableKey = restrict;
  }

  key: string;
  value: JsonEditorField | string | number | boolean;
  type: string;

  isArrayItem: boolean;

  disableKey: boolean;
  disableType: boolean;
  disableRemove: boolean;
  disableValue: boolean;
  disableAddKey: boolean;
}